import React, { useCallback, useState } from 'react';
import {
  Select, MenuItem, Grid, Box,
} from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';
import clsx from 'clsx';

import StyledInput from '../../actions/StyledInput';
import StudioToolTip from '../../actions/StudioToolTip';
import { StudioControlStyles } from '../../styles';
import {
  setDropdownSelectMode, setCameraId,
} from '../../../../store/modules/studio/actions';
import {
  selectCameraRecording,
  selectCameraId, selectCountdownCamera,
} from '../../../../store/modules/studio/selectors';

type Props = {
  videoDevices: MediaDeviceInfo[];
}

const SelectMediaDeviceAction = ({videoDevices}: Props) => {
  const classes = StudioControlStyles();

  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);
  const cameraId = useSelector(selectCameraId);
  const isRecording = useSelector(selectCameraRecording);
  const isCountdown = useSelector(selectCountdownCamera);

  /* eslint-disable react-hooks/exhaustive-deps */
  const onChange = useCallback((event: React.ChangeEvent<{value: unknown}>) => {
    dispatch(setCameraId(event.target.value as string));
  }, [dispatch, cameraId]);

  const openHandler = useCallback(() => {
    setOpen(true);
    dispatch(setDropdownSelectMode(true));
  }, [dispatch, setOpen]);

  const closeHandler = useCallback(() => {
    setOpen(false);
    dispatch(setDropdownSelectMode(false));
  }, [dispatch, setOpen]);

  return (
    <>
      <Grid item container>
        <StudioToolTip title="Select which camera will be used">
          <Box style={{ width: '100%' }}>
            <p className={classes.label}>Camera</p>
              <Select
                open={open}
                data-tip="Change camera"
                variant="outlined"
                className={clsx(classes.selection, classes.selectAutoWidth)}
                input={<StyledInput/>}
                value={cameraId}
                onChange={onChange}
                MenuProps={{
                  style: {
                    zIndex: 2147483101,
                  },
                }}
                data-intercom-target="Dropdown: Camera"
                onOpen={openHandler}
                onClose={closeHandler}
                disabled={isRecording || !videoDevices.length || isCountdown}
              >
                {videoDevices.map((item) => (
                <MenuItem key={item.deviceId} value={item.deviceId}>
                  {item.label}
                </MenuItem>
                ))}
              </Select>
          </Box>
        </StudioToolTip>
      </Grid>
    </>
  );
};

export default SelectMediaDeviceAction;
